import type { FaireProductEntity } from "../../entity_types/product";

export const p_9rdqara3vd: FaireProductEntity = {
  token: "p_9rdqara3vd",
  type: "product",
  name: "New Bud Baby Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/d0e188154dbba2d7b08e3749be0e977b9eb2dd7bddd3fbccada54ffb5fdf7ede.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6d73ca8d20f35d2e477dc935f61b856d0f95f39c7f009ff2c9296e9f3cafad1a.png",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:59.429Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
